<template>
  <div class="politica-privacidade">
    <PoliticaComp />
</div>
</template>

<script>

import PoliticaComp from '@/components/PoliticaComp.vue'

export default {
  name: 'PoliticaView',
  components: {
    PoliticaComp
  }
}
</script>
